<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="产品出库"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5%"
    :close-on-click-modal="false"
  >
    <el-row :gutter="20">
      <el-col :span="16">
        <div class="border-style">基本信息</div>
        <el-form
          :model="item"
          ref="itemform"
          label-width="120px"
          :rules="rules"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="产品型号名称">
                <el-input
                  v-if="item.IpcProductModel"
                  v-model.trim="item.IpcProductModel.Name"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品型号">
                <el-input
                  v-if="item.IpcProductModel"
                  v-model.trim="item.IpcProductModel.Number"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="产品SN">
                <el-input v-model.trim="item.SN" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入库日期" prop="StockinAt">
                <el-date-picker
                  v-model="item.StockinAt"
                  style="width: 100%"
                  type="date"
                  disabled
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="机器码">
            <el-input v-model.trim="item.MachineCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model.trim="item.Remark"
              :autosize="{ minRows: 2 }"
              type="textarea"
              disabled
            ></el-input>
          </el-form-item>

          <el-divider></el-divider>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="合同编号" prop="ContractNos">
                <el-select
                  v-model="item.ContractNos"
                  multiple
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择或输入合同编号"
                  style="width: 100%"
                >
                  <el-option
                    v-for="contract in contractList"
                    :key="contract"
                    :label="contract"
                    :value="contract"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户名称" prop="ClientID">
                <select2
                  labelName="ClientName"
                  v-model="item.ClientID"
                  url="client/list"
                  filterable
                  :clearable="false"
                  :currentList="currentClient"
                  placeholder="选择客户"
                  no-data-text="没有客户"
                  :urlParams="{
                    where: {},
                  }"
                  q="ClientName:like"
                  :qinwhere="true"
                  :queryOne="false"
                  style="width: 100%"
                ></select2>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出库日期" prop="StockoutAt">
                <el-date-picker
                  v-model="item.StockoutAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="text-align: right;width: 108px;padding-top: 5px;color:#606266" class="pull-left">
                绑定站点
              </div>
              <div class="mar-btm">
                <el-form-item label="" prop="StationID">
                  <select2
                    labelName="Name"
                    v-model="item.StationID"
                    url="station/list"
                    filterable
                    clearable
                    placeholder="选择站点"
                    no-data-text="没有站点"
                    :currentList="currentStation"
                    :urlParams="{
                      where: {},
                    }"
                    q="Name:like"
                    :qinwhere="true"
                    :queryOne="false"
                    style="width: 100%"
                  ></select2>
                </el-form-item>              
                <div class="mar-btm" style="color:#c0c4cc;margin-top: -15px;margin-left: 65px;margin-bott: 50px;margin-bottom: 5px;">
                  慎用：选择的站点将使用当前产品，并且取消关联原产品
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出库单号" prop="CheckoutNo">
                <el-input
                  v-model.trim="item.CheckoutNo"
                  placeholder="请输入出库单号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库经办人" prop="Operator">
                <el-input
                  v-model.trim="item.Operator"
                  placeholder="请输入经办人"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="领用部门" prop="RecipientDeptID">
                <select2
                  style="width: 100%"
                  v-model="item.RecipientDeptID"
                  url="department"
                  :clearable="false"
                  :currentList="currentRecipientDept"
                  placeholder="请选择部门"
                  no-data-text="没有部门"
                  :urlParams="{
                    where: {},
                  }"
                  q="Name:like"
                  :qinwhere="true"
                  :queryOne="false"
                ></select2>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="领用人" prop="Recipient">
                <el-input
                  v-model.trim="item.Recipient"
                  placeholder="请输入领用人"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="出库备注" prop="StockoutReason">
            <el-input
              v-model.trim="item.StockoutReason"
              :autosize="{ minRows: 2 }"
              type="textarea"
              placeholder="请输入出库备注"
            ></el-input>
          </el-form-item>
          <el-form-item label="文件上传" prop="file">
            <el-upload
              ref="upload"
              action=""
              :http-request="httpRequest"
              :headers="uploadHeader"
              :on-remove="handleRemove"
              :on-error="handleError"
              :file-list="fileList"
              :on-preview="handlePreview"
            >
              <el-button size="mini" type="primary">选择文件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <div class="border-style">日志信息</div>
        <div class="dialogDiv">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="
                $sys.dateFormat(activity.UpdatedAt) + ' ' + activity.Operator
              "
              placement="top"
            >
              <el-card>
                <p style="margin-top: 0px; margin-bottom: 0px">
                  {{ activity.Content }}
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>

    <div class="border-style">相关配件</div>
    <el-table :data="item.IpcAccessories" v-loading="loading">
      <el-table-column prop="IpcAccessoryModel.Name" label="配件名称" />
      <el-table-column prop="IpcAccessoryModel.Brand" label="品牌" />
      <el-table-column prop="IpcAccessoryModel.ModelNumber" label="型号" />
      <el-table-column prop="SN" label="配件SN">
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.SN }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      loading: false,
      rules: {
        StockoutAt: [
          { required: true, message: "出库日期不能为空", trigger: "blur" },
        ],
        CheckoutNo: [
          { required: true, message: "出库单号不能为空", trigger: "blur" },
        ],
        ClientID: [
          { required: true, message: "客户名称不能为空", trigger: "blur" },
        ],
        Operator: [
          { required: true, message: "出库经办人不能为空", trigger: "blur" },
        ],
        ContractNos: [
          { required: true, message: "合同编号不能为空", trigger: "blur" },
        ],
        RecipientDeptID: [
          { required: true, message: "领用部门不能为空", trigger: "blur" },
        ],
        Recipient: [
          { required: true, message: "领用人不能为空", trigger: "blur" },
        ],
        StockoutReason: [{ max: 64000, message: "内容过多", trigger: "blur" }],
      },
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
      submitting: false,
      activities: [], //日志

      contractList: [], //合同
      currentClient: [],
      currentRecipientDept: [],
      currentStation: [],
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      fileList: [],
      removeList: [],
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      this.$axios
        .get(`ipc/product/${this.value.ID}`)
        .then((response) => {
          this.item = response.data;

          if (this.item.Attachments && this.item.Attachments.length > 0) {
            this.item.Attachments.forEach((att) => {
              this.index += 1;
              this.fileList.push({
                uid: this.index,
                name: att.Name,
                url: att.Url,
              });
            });
          }

          if (this.item.IpcProductModel != null) {
            this.currentProductModel = [
              {
                ID: this.item.IpcProductModelID,
                NameNumber: this.item.IpcProductModel.NameNumber,
              },
            ];
          }
          
          if (this.item.Client != null) {
            this.currentClient = [
              {
                ID: this.item.ClientID,
                ClientName: this.item.Client.ClientName,
              },
            ];
          }

          if (this.item.RecipientDept != null) {
            this.currentRecipientDept = [
              {
                ID: this.item.RecipientDeptID,
                Name: this.item.RecipientDept.Name,
              },
            ];
          }
          if (this.item.Station != null) {
            this.currentStation = [
              {
                ID: this.item.Station,
                Name: this.item.Station.Name,
              },
            ];
          }

          this.item.ClientID =
            this.item.ClientID == 0 ? "" : this.item.ClientID;

          this.item.RecipientDeptID =
            this.item.RecipientDeptID == 0 ? "" : this.item.RecipientDeptID;

          this.item.StationID =
            this.item.StationID == 0 ? "" : this.item.StationID;

          this.item.StockoutAt = new Date();
          this.item.Operator = this.$store.state.Auth.user.Name;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });

      this.getLog();
      this.getContractList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();

      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      this.fileList = [];
      this.removeList = [];
    },
    getLog() {
      this.$axios
        .get(`ipc/product/${this.value.ID}/record`, {
          params: {
            ...this.pager,
            order: ["-updated_at","-id"],
          },
        })
        .then((response) => {
          this.activities = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getContractList() {
      this.$axios
        .get("ipc/product/stock-contracts")
        .then((response) => {
          this.contractList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },

    //确认出库
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;

        //排除删除的附件
        if (this.removeList.length !== 0) {
          this.removeList.forEach((url) => {
            this.item.Attachments.splice(
              this.item.Attachments.findIndex((item) => item.Url === url),
              1
            );
          });
          this.$axios.delete("ipc/attachmentDelete", {
            data: { urls: this.removeList },
          });
        }
        this.item.StationID = this.item.StationID == "" ? 0 : this.item.StationID;

        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: `ipc/product/stock-out/${this.item.ID}`,
            method: "put",
            data: itemData,
          })
          .then(() => {
            this.$message.success("出库成功");
            this.submitting = false;

            if (this.fileList.length > 0) {
              this.$refs.upload.clearFiles();
            }
            this.fileList = [];
            this.removeList = [];
            this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },

    // param是自带参数。 this.$refs.upload.submit() 会自动调用 httpRequest方法.在里面取得file
    httpRequest(params) {
      var formData = new FormData();
      formData.append("file", params.file);
      // formData.append("id", this.item.ID);
      this.$axios
        .post(`ipc/product/stock-upload`, formData)
        .then((response) => {
          this.item.Attachments =
            this.item.Attachments === null ? [] : this.item.Attachments;
          this.item.Attachments.push(response.data);

          this.fileList.push({
            uid: params.file.uid,
            name: response.data.Name,
            url: response.data.Url,
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    handleRemove(file) {
      this.fileList.forEach((obj) => {
        if (obj.uid === file.uid) {
          this.removeList.push(obj.url);
          this.fileList.splice(
            this.fileList.findIndex((item) => item.uid === obj.uid),
            1
          );
        }
      });
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.setAttribute("download", file.name);
      a.setAttribute("href", file.url);
      a.click();
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
  },
};
</script>
<style scoped>
.el-divider--horizontal {
  margin: 0px 0 12px 0;
}
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}
.dialogDiv {
  height: 480px;
  overflow: auto;
  padding-left: 10px;
  padding-right: 10px;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>
